module.exports = __webpack_public_path__ + "img/pic-1.5126365d.png";